<div class="min-h-screen bg-gradient-to-br from-[#0f172a] via-[#000000] to-[#0f172a] relative overflow-hidden">
  <!-- Background Animated Elements -->
  <div class="absolute inset-0 overflow-hidden">
    <div
      class="absolute w-[800px] h-[800px] bg-[#6138e6]/20 rounded-full blur-3xl -top-48 -left-48"
      [ngStyle]="{ transform: 'translateY(' + scrollY * 0.3 + 'px)' }"
    ></div>
    <div
      class="absolute w-[600px] h-[600px] bg-cyan-500/20 rounded-full blur-3xl top-1/3 -right-32"
      [ngStyle]="{ transform: 'translateY(' + scrollY * 0.2 + 'px)' }"
    ></div>
    <div
      class="absolute w-[700px] h-[700px] bg-blue-500/20 rounded-full blur-3xl bottom-0 left-1/3"
      [ngStyle]="{ transform: 'translateY(' + scrollY * 0.15 + 'px)' }"
    ></div>
  </div>

  <!-- Navigation -->
  <nav class="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-white/5 border-b border-white/10">
    <div class="responsive-full-width mx-auto py-4 flex justify-between items-center">
      <div class="flex items-center">
        <div class="w-10 h-10 rounded-lg flex items-center justify-center">
          <img src="logos/ofnos/isotipo_blanco.png" alt="Ofnos" />
        </div>
        <div class="w-24 h-10 rounded-lg flex items-center justify-center">
          <img src="logos/ofnos/logotipo2_blanco.png" alt="Ofnos" />
        </div>
      </div>

      <div class="hidden md:flex items-center gap-8">
        <button (click)="scrollToSection('about')" class="text-white/80 hover:text-white">About</button>
        <button (click)="scrollToSection('projects')" class="text-white/80 hover:text-white">Projects</button>
        <button (click)="scrollToSection('contact')" class="text-white/80 hover:text-white">Contact</button>
        <button
          (click)="scrollToSection('contact')"
          class="bg-gradient-to-r from-cyan-500 to-[#6138e6] hover:from-cyan-600 hover:to-purple-600 text-white rounded-lg px-4 py-2 shadow-lg"
        >
          Get Started
        </button>
      </div>
    </div>
  </nav>

  <!-- Hero Section -->
  <section
    class="relative min-h-screen flex flex-col items-center justify-center text-center pt-20 responsive-full-width mx-auto"
  >
    <div class="inline-block mb-6 px-6 py-2 rounded-full bg-white/10 border border-white/20" [style.opacity]="1 - scrollY / 400">
      <span class="text-cyan-300 text-sm font-medium">✨ Tailor made solutions</span>
    </div>

    <h1 class="text-6xl font-bold text-white mb-6 leading-tight" [style.opacity]="1 - scrollY / 400">
      We Build Software <br />
      <span class="bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">That Suits You</span>
    </h1>

    <p class="text-xl text-white/70 mb-12 max-w-3xl mx-auto" [style.opacity]="1 - scrollY / 400">
      Transforming old processes into automation opportunities to leverage the full potential of your business
    </p>

    <div class="flex flex-col sm:flex-row justify-center gap-4" [style.opacity]="1 - scrollY / 400">
      <button
        (click)="scrollToSection('projects')"
        class="bg-gradient-to-r from-cyan-500 to-[#6138e6] text-white rounded-lg px-8 py-4 hover:from-cyan-600 hover:to-purple-600"
      >
        Explore Our Solutions →
      </button>
      <button
        (click)="scrollToSection('contact')"
        class="bg-white/10 border border-white/20 text-white rounded-lg px-8 py-4 hover:bg-white/20"
      >
        Let's Talk
      </button>
    </div>

    <!-- Stats -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mt-20 max-w-4xl mx-auto">
      @for (stat of stats; track stat.label) {
      <div class="bg-white/5 border border-white/10 p-6 rounded-lg hover:bg-white/10 transition-all duration-300 hover:scale-105">
        <div class="text-4xl font-bold text-white mb-2">{{ stat.value }}</div>
        <div class="text-white/60">{{ stat.label }}</div>
      </div>
      }
    </div>
  </section>

  <!-- About Section -->
  <section id="about" class="relative py-24 responsive-full-width mx-auto">
    <div class="text-center mb-16">
      <h2 class="text-4xl font-bold text-white mb-4">Innovating your business to the digital era</h2>
      <p class="text-white/70 max-w-2xl mx-auto">
        At Ofnos, we understand the importance of evolving your business to new technologies to stay competitive in the market.
        Our approach focus primarily on providing scalable, reliable, and efficient solutions that reflect our commitment to your
        success.
      </p>
    </div>

    <div class="rounded-xl h-[410px] mb-5">
      <div class="relative h-full rounded-2xl">
        <div class="z-0 h-full rounded-2xl">
          <img
            [src]="about[currentAboutIndex].image"
            alt="About Us"
            class="rounded-2xl"
            style="object-fit: cover; object-position: center"
          />
        </div>
        <div class="absolute top-0 left-0 z-10 h-full w-full rounded-2xl bg-black/40"></div>
        <div class="absolute z-20 top-0 left-0 w-full h-full flex flex-col justify-center p-10">
          <div class="flex items-center h-1/2 gap-8 w-1/3">
            <div class="h-full bg-gray-200 w-0.5 mb-4">
              <div
                class="bg-blue-600 w-0.5 transition-all ease-linear duration-500"
                [style.height]="aboutProgressPercentage"
              ></div>
            </div>
            <div>
              <p class="text-white font-semibold text-5xl">{{ about[currentAboutIndex].emphasis }}</p>
              <p class="text-white">{{ about[currentAboutIndex].description }}</p>
            </div>
          </div>
          <h3 class="text-2xl font-semibold text-white mb-3">{{ about[currentAboutIndex].title }}</h3>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-3 gap-6">
      @for (about of about; track about.emphasis; let index = $index) {
      <div class="col-span-1" (click)="setAbout(index)">
        <div class="w-full mx-auto bg-gray-200 h-0.5 mb-2">
          <div
            class="bg-blue-600 h-0.5 transition-all ease-linear duration-500"
            [style.width]="currentAboutIndex === index ? aboutProgressPercentage : '100%'"
          ></div>
        </div>
        <p class="text-white/60 text-center cursor-pointer">{{ about.emphasis }}</p>
      </div>
      }
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
      @for (feature of features; track feature.title) {
      <div
        class="bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-all duration-300 hover:scale-105 text-center"
      >
        <div
          class="w-16 h-16 mx-auto bg-gradient-to-br from-cyan-500 to-[#6138e6] rounded-2xl flex items-center justify-center mb-6"
        >
          <ng-icon [name]="feature.icon" class="text-4xl" color="white"></ng-icon>
        </div>
        <h3 class="text-xl font-semibold text-white mb-3">{{ feature.title }}</h3>
        <p class="text-white/60">{{ feature.description }}</p>
      </div>
      }
    </div>
  </section>

  <!-- Projects -->
  <section id="projects" class="relative py-24 responsive-full-width mx-auto">
    <div class="text-center mb-16">
      <h2 class="text-4xl font-bold text-white mb-4">Full Solutions Portfolio</h2>
      <p class="text-white/70 max-w-2xl mx-auto">
        Explore some of our end-to-end solutions that we have developed for some of our clients.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      @for (project of portfolio; track project.title) {
      <div class="bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 transition-all duration-300 hover:scale-105">
        <div class="h-72">
          <img [src]="project.image" alt="Project" class="object-cover object-center rounded-t-lg" />
        </div>
        <div class="p-6 flex flex-col justify-between">
          <div>
            <h3 class="text-xl font-semibold text-white my-3">{{ project.title }}</h3>
            <p class="text-white/60">{{ project.description }}</p>
          </div>

          @if (project.websiteUrl) {
          <div class="mt-8">
            <button
              (click)="navigateToWebsite(project.websiteUrl)"
              class="bg-gradient-to-r from-cyan-500 to-[#6138e6] hover:from-cyan-600 hover:to-purple-600 text-white rounded-lg px-4 py-2 shadow-lg"
            >
              Visit Website →
            </button>
          </div>
          }
        </div>
      </div>

      }
    </div>
  </section>

  <!-- Contact -->
  <section id="contact" class="relative py-24 responsive-full-width mx-auto">
    <div class="text-center mb-16">
      <h2 class="text-4xl font-bold text-white mb-4">Let's Work Together</h2>
      <p class="text-white/70 max-w-2xl mx-auto">
        We're here to help you with your project. Get in touch with us to discuss your needs and explore how we can help.
      </p>
    </div>
    <!-- Contact Info Section -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Get in Touch Card -->
      <div class="bg-white/5 backdrop-blur-md border border-white/10 p-8 rounded-2xl">
        <h3 class="text-2xl font-semibold text-white mb-6">Get In Touch</h3>

        <div class="space-y-6">
          @for (item of contactItems; track item.label) {
          <div class="flex items-start gap-4">
            <div
              class="w-12 h-12 bg-gradient-to-br from-cyan-500 to-[#6138e6] rounded-xl flex items-center justify-center flex-shrink-0"
            >
              <ng-icon [name]="item.icon" class="text-3xl text-white"></ng-icon>
            </div>
            <div>
              <div class="text-white/60 text-sm mb-1">{{ item.label }}</div>
              <div class="text-white font-medium">{{ item.value }}</div>
            </div>
          </div>
          }
        </div>
      </div>
      <div>
        <!-- Follow Us Card -->
        <div class="bg-white/5 backdrop-blur-md border border-white/10 p-8 rounded-2xl">
          <h3 class="text-xl font-semibold text-white mb-4">Follow Us</h3>
          <div class="flex gap-4">
            @for (social of socials; track social.label) {
            <button
              [attr.aria-label]="social.label"
              class="w-12 h-12 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl flex items-center justify-center hover:bg-white/20 transition-all duration-300 hover:scale-110"
              (click)="navigateToWebsite(social.url)"
            >
              <img [src]="social.icon" [alt]="social.label" class="w-6 h-6" />
            </button>
            }
          </div>
        </div>

        <!-- Schedule Consultation Card -->
        <div class="mt-4 bg-gradient-to-br from-cyan-500/20 to-[#6138e6]/20 backdrop-blur-md border border-white/20 p-8 rounded-2xl">
          <h3 class="text-xl font-semibold text-white mb-2">Ready to Start?</h3>

          <button
            class="w-full bg-gradient-to-r from-cyan-500 to-[#6138e6] hover:from-cyan-600 hover:to-purple-600 text-white border-0 rounded-xl py-3 transition-all"
            (click)="navigateToWebsite('https://outlook.office.com/book/OfnosFirstContact@ofnos.com')"
            >
            Schedule Free Consultation
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="relative pt-4 pb-12 border-t border-white/10 text-center text-white/60">
    <div class="flex justify-center items-center gap-2 mb-4">
      <div class="w-32 h-32 rounded-lg flex items-center justify-center">
        <img src="logos/ofnos/imagotipo3_blanco.png" alt="Ofnos" />
      </div>
    </div>
    © 2025 Ofnos. All rights reserved.
  </footer>
</div>
